var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initMainProduct = /* @__PURE__ */ __name(($formEl, $refs, productHandle, isProductBar = false) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P;
  let scrollContainer = $refs.scrollContainer;
  let gallery = $refs.gallery;
  let init = true;
  if (!scrollContainer) {
    scrollContainer = $formEl.querySelector(`[x-ref="scrollContainer"]`);
  }
  if (!gallery) {
    gallery = $formEl.querySelector(`[x-ref="gallery"]`);
  }
  const cart = window.Alpine.store("cart");
  const isPrimary = !isProductBar && new RegExp(`^/products/${productHandle}`, "gi").test((_a = _stores == null ? void 0 : _stores.router) == null ? void 0 : _a.pathname);
  const quickView = $formEl.hasAttribute("data-quick-view");
  const settings = utils.JSONParse($formEl.getAttribute("data-settings"));
  const columnElements = [gallery, $refs == null ? void 0 : $refs.content, $refs == null ? void 0 : $refs.thumbnails].filter(Boolean);
  const product = utils.JSONParse(
    (_d = (_b = document.querySelector(`[data-primary-product-data="${productHandle}"]`)) == null ? void 0 : _b.innerHTML) != null ? _d : (_c = document.querySelector(`[data-product-data="${productHandle}"]`)) == null ? void 0 : _c.innerHTML
  );
  if (isPrimary) {
    const url = new URL(window.location.href);
    const variantId = url.searchParams.get("variant");
    product.selected_variant_id = variantId ? +variantId : product.selected_variant_id;
  }
  const selected_variant = ((_e = product == null ? void 0 : product.variants) == null ? void 0 : _e.find((v) => v.id === product.selected_variant_id)) || ((_f = product == null ? void 0 : product.variants) == null ? void 0 : _f.find(
    (v) => {
      var _a2;
      return v.id && ((_a2 = product.options_with_values) == null ? void 0 : _a2.every((option, i) => _product.lastOptions[utils.handlelize(option == null ? void 0 : option.name)] === v.options[i]));
    }
  )) || ((_g = product == null ? void 0 : product.variants) == null ? void 0 : _g.find(
    (v) => {
      var _a2;
      return v.id && ((_a2 = product.options_with_values.slice(0, product.options_with_values.length - 1)) == null ? void 0 : _a2.every((option, i) => _product.lastOptions[utils.handlelize(option == null ? void 0 : option.name)] === v.options[i]));
    }
  )) || (product.options_with_values.length >= 3 ? (_h = product == null ? void 0 : product.variants) == null ? void 0 : _h.find(
    (v) => {
      var _a2;
      return v.id && ((_a2 = product.options_with_values.slice(0, product.options_with_values.length - 2)) == null ? void 0 : _a2.every((option, i) => _product.lastOptions[utils.handlelize(option == null ? void 0 : option.name)] === v.options[i]));
    }
  ) : null) || ((_i = product == null ? void 0 : product.variants) == null ? void 0 : _i.find(
    (v) => {
      var _a2;
      return v.id && ((_a2 = product.options_with_values) == null ? void 0 : _a2.some((option, i) => _product.lastOptions[utils.handlelize(option == null ? void 0 : option.name)] === v.options[i]));
    }
  )) || ((_j = product == null ? void 0 : product.variants) == null ? void 0 : _j.find((v) => v.id === product.selected_or_first_available_variant_id)) || ((_k = product == null ? void 0 : product.variants) == null ? void 0 : _k[0]);
  const selling_plan_allocations = selected_variant == null ? void 0 : selected_variant.selling_plan_allocations;
  const selected_selling_plan = (_l = selling_plan_allocations == null ? void 0 : selling_plan_allocations[0]) == null ? void 0 : _l.selling_plan;
  const selling_plan_discount_wording = +((_n = (_m = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _m[0]) == null ? void 0 : _n.value) ? ((_p = (_o = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _o[0]) == null ? void 0 : _p.value_type) === "fixed_amount" ? `${utils.formatMoney((_r = (_q = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _q[0]) == null ? void 0 : _r.value)}` : ((_t = (_s = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _s[0]) == null ? void 0 : _t.value_type) === "percentage" ? `${(_v = (_u = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _u[0]) == null ? void 0 : _v.value}%` : "" : "";
  const gallerySettings = utils.JSONParse(gallery == null ? void 0 : gallery.getAttribute("data-settings"));
  const thumbnailSettings = utils.JSONParse(
    (_w = $refs.thumbnails) == null ? void 0 : _w.getAttribute("data-settings")
  );
  const mediaElements = [...(_x = gallery == null ? void 0 : gallery.querySelectorAll("[data-main-product-images] [data-media-id]")) != null ? _x : []].map((element) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2;
    return {
      element,
      mediaId: +element.getAttribute("data-media-id"),
      metafield: element.hasAttribute("data-metafield-media"),
      media: (_g2 = (_a2 = product == null ? void 0 : product.media) == null ? void 0 : _a2.find((media) => media.id === +element.getAttribute("data-media-id"))) != null ? _g2 : (_f2 = (_e2 = (_d2 = (_c2 = (_b2 = product == null ? void 0 : product.variants) == null ? void 0 : _b2.find((v) => {
        var _a3, _b3, _c3;
        return (_c3 = (_b3 = (_a3 = v.metafields) == null ? void 0 : _a3.smart) == null ? void 0 : _b3.images) == null ? void 0 : _c3.some((image) => image.id === +element.getAttribute("data-media-id"));
      })) == null ? void 0 : _c2.metafields) == null ? void 0 : _d2.smart) == null ? void 0 : _e2.images) == null ? void 0 : _f2.find((image) => image.id === +element.getAttribute("data-media-id"))
    };
  });
  const thumbnailMediaElements = [...(_z = (_y = $refs.thumbnails) == null ? void 0 : _y.querySelectorAll("[data-media-id]")) != null ? _z : []].map((element) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2;
    return {
      element,
      mediaId: +element.getAttribute("data-media-id"),
      metafield: element.hasAttribute("data-metafield-media"),
      media: (_g2 = (_a2 = product == null ? void 0 : product.media) == null ? void 0 : _a2.find((media) => media.id === +element.getAttribute("data-media-id"))) != null ? _g2 : (_f2 = (_e2 = (_d2 = (_c2 = (_b2 = product == null ? void 0 : product.variants) == null ? void 0 : _b2.find((v) => {
        var _a3, _b3, _c3;
        return (_c3 = (_b3 = (_a3 = v.metafields) == null ? void 0 : _a3.smart) == null ? void 0 : _b3.images) == null ? void 0 : _c3.some((image) => image.id === +element.getAttribute("data-media-id"));
      })) == null ? void 0 : _c2.metafields) == null ? void 0 : _d2.smart) == null ? void 0 : _e2.images) == null ? void 0 : _f2.find((image) => image.id === +element.getAttribute("data-media-id"))
    };
  });
  let discounted_price = selected_variant == null ? void 0 : selected_variant.price;
  const price_adjustment = (_F = (_A = selected_selling_plan == null ? void 0 : selected_selling_plan.price_adjustments) == null ? void 0 : _A[0]) != null ? _F : (_E = (_D = (_C = (_B = selected_variant == null ? void 0 : selected_variant.selling_plan_allocations) == null ? void 0 : _B[0]) == null ? void 0 : _C.selling_plan) == null ? void 0 : _D.price_adjustments) == null ? void 0 : _E[0];
  if ((price_adjustment == null ? void 0 : price_adjustment.value_type) === "fixed_amount") {
    discounted_price = Math.max(discounted_price - Math.round(+(price_adjustment == null ? void 0 : price_adjustment.value)), 0);
  }
  if ((price_adjustment == null ? void 0 : price_adjustment.value_type) === "percentage") {
    discounted_price = Math.max(discounted_price - Math.round(+(price_adjustment == null ? void 0 : price_adjustment.value) / 100 * discounted_price), 0);
  }
  const available_quantity = (selected_variant == null ? void 0 : selected_variant.inventory_management) === "shopify" && (selected_variant == null ? void 0 : selected_variant.inventory_policy) === "deny" ? (selected_variant == null ? void 0 : selected_variant.inventory_quantity) - ((_H = (_G = cart == null ? void 0 : cart.state) == null ? void 0 : _G.items) == null ? void 0 : _H.reduce((acc, line) => line.variant_id === selected_variant.id ? acc + line.quantity : acc, 0)) : 999999;
  const state = Alpine.reactive({
    element: $formEl,
    count: 0,
    manual_discount: 0,
    isPrimary,
    product,
    selected_media_id: (_J = (_I = product == null ? void 0 : product.media) == null ? void 0 : _I[0]) == null ? void 0 : _J.id,
    show_complementary_products: true,
    properties: {},
    selected_variant,
    selling_plan_allocations,
    selected_price: discounted_price,
    selected_compare_at_price: Math.max(selected_variant == null ? void 0 : selected_variant.compare_at_price, selected_variant == null ? void 0 : selected_variant.price),
    upsell_total: 0,
    upsell_compare_at_total: 0,
    selected_selling_plan: null,
    last_selected_selling_plan: selected_selling_plan,
    selling_plan_discount_wording,
    isAdding: false,
    dynamic_buy_button: null,
    options: selected_variant == null ? void 0 : selected_variant.options,
    quantity: 1,
    quantity_limit: available_quantity,
    sibling_handle: "",
    disable_add_to_cart: /* @__PURE__ */ new Set(),
    required_combine_items: [],
    required_combine_quantity: 0,
    hasVariants: ((_K = product == null ? void 0 : product.variants) == null ? void 0 : _K.length) > 1 || ((_M = (_L = product == null ? void 0 : product.variants) == null ? void 0 : _L[0]) == null ? void 0 : _M.title) !== "Default Title",
    hasSubscription: !!((_N = selected_variant == null ? void 0 : selected_variant.options) == null ? void 0 : _N.length),
    soldOut: (selected_variant == null ? void 0 : selected_variant.inventory_management) === "shopify" && (selected_variant == null ? void 0 : selected_variant.inventory_policy) === "deny" && (selected_variant == null ? void 0 : selected_variant.inventory_quantity) - ((_P = (_O = cart == null ? void 0 : cart.state) == null ? void 0 : _O.items) == null ? void 0 : _P.reduce((acc, line) => line.variant_id === selected_variant.id ? acc + line.quantity : acc, 0)) <= 0,
    available_quantity,
    upsell_items: /* @__PURE__ */ new Map()
  });
  const handlePopState = /* @__PURE__ */ __name((e) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2;
    const url = new URL(window.location.href);
    const selling_plan_id = +url.searchParams.get("selling_plan");
    const variant_id = +url.searchParams.get("variant");
    if (!variant_id) return;
    if (((_a2 = state.selected_variant) == null ? void 0 : _a2.id) !== variant_id) {
      state.selected_variant = (_d2 = (_c2 = (_b2 = state.product) == null ? void 0 : _b2.variants) == null ? void 0 : _c2.find((variant) => variant.id === variant_id)) != null ? _d2 : state.selected_variant;
      state.options = (_e2 = state.selected_variant) == null ? void 0 : _e2.options;
    }
    if (selling_plan_id !== ((_f2 = state.selected_selling_plan) == null ? void 0 : _f2.id)) {
      state.selected_selling_plan = (_j2 = (_i2 = (_h2 = (_g2 = state.selected_variant) == null ? void 0 : _g2.selling_plan_allocations) == null ? void 0 : _h2.find((plan) => plan.selling_plan.id === selling_plan_id)) == null ? void 0 : _i2.selling_plan) != null ? _j2 : state.selected_selling_plan;
    }
  }, "handlePopState");
  const styleDynamicBuyButton = /* @__PURE__ */ __name((element) => {
    var _a2, _b2;
    const cssClass = element.getAttribute("data-button-class");
    const previewButton = element.querySelector("[data-pre-styled-button]");
    element.style.setProperty("--shopify-accelerated-checkout-button-block-size", (_a2 = getComputedStyle(previewButton)) == null ? void 0 : _a2.height);
    element.style.setProperty(
      "--shopify-accelerated-checkout-button-border-radius",
      (_b2 = getComputedStyle(previewButton)) == null ? void 0 : _b2.borderRadius
    );
    previewButton.remove();
  }, "styleDynamicBuyButton");
  const handleAddToCart = /* @__PURE__ */ __name(async (e) => {
    var _a2, _b2, _c2, _d2, _e2, _f2;
    if (state.disable_add_to_cart.size > 0) return;
    e.preventDefault();
    e.stopPropagation();
    const random_id = utils.shortUUID();
    const properties = {};
    if (state.upsell_items.size && ((_a2 = [...state.upsell_items.values()]) == null ? void 0 : _a2.some((item) => item.bundle)) || ((_b2 = state.required_combine_items) == null ? void 0 : _b2.length)) {
      properties["_p_id"] = `${random_id}`;
    }
    const formElement = $formEl.tagName === "FORM" ? $formEl : document.querySelector(`form[data-handle="${(_d2 = (_c2 = state.product) == null ? void 0 : _c2.handle) != null ? _d2 : productHandle}"]`);
    if (formElement.tagName === "FORM") {
      (_e2 = Object.entries(utils.serializeForm(formElement))) == null ? void 0 : _e2.forEach(([key, value]) => {
        if (key.includes("properties[") && value) {
          properties[key.replace(/^properties\[(.*)]$/gi, "$1")] = value;
        }
      });
    }
    state.isAdding = true;
    const data = await _cart.add({
      items: [
        {
          id: state.selected_variant.id,
          quantity: state.quantity,
          selling_plan: (_f2 = state.selected_selling_plan) == null ? void 0 : _f2.id,
          properties: {
            ...properties,
            ...state.properties
          }
        },
        ...[...state.upsell_items.values()].map((entry) => {
          var _a3, _b3, _c3, _d3;
          return {
            id: entry.id,
            selling_plan: (_d3 = (_c3 = (_b3 = (_a3 = entry.variant) == null ? void 0 : _a3.selling_plan_allocations) == null ? void 0 : _b3.find(
              (plan) => {
                var _a4, _b4;
                return ((_a4 = plan.selling_plan) == null ? void 0 : _a4.id) === ((_b4 = state.selected_selling_plan) == null ? void 0 : _b4.id);
              }
            )) == null ? void 0 : _c3.selling_plan) == null ? void 0 : _d3.id,
            quantity: state.quantity * entry.quantity,
            properties: {
              ...entry.properties,
              _p_id_link: (entry == null ? void 0 : entry.bundle) ? `${random_id}` : void 0,
              _p_required: (entry == null ? void 0 : entry.auto_addon) ? "true" : void 0,
              _p_fixed_quantity: !(entry == null ? void 0 : entry.variable_quantity) ? "true" : void 0
            }
          };
        }),
        ...state.required_combine_items.reduce((acc, item) => {
          var _a3, _b3, _c3, _d3;
          const itemIndex = acc.findIndex((addedItem) => addedItem.id === item.id);
          if (itemIndex !== -1) {
            acc[itemIndex].quantity += state.quantity;
            acc[itemIndex].properties["_p_quantity"] = `${acc[itemIndex].quantity}`;
            return acc;
          }
          acc.push({
            id: item.id,
            quantity: state.quantity,
            selling_plan: ((_a3 = state.selected_selling_plan) == null ? void 0 : _a3.id) ? (_d3 = (_c3 = (_b3 = item.selling_plan_allocations) == null ? void 0 : _b3.find((plan) => {
              var _a4, _b4;
              return ((_a4 = plan.selling_plan) == null ? void 0 : _a4.name) === ((_b4 = state.selected_selling_plan) == null ? void 0 : _b4.name);
            })) == null ? void 0 : _c3.selling_plan) == null ? void 0 : _d3.id : void 0,
            properties: {
              _p_id_link: `${random_id}`
            }
          });
          return acc;
        }, [])
      ]
    });
    state.isAdding = false;
    if (!data.cart_error) {
      _stores.modal.setId("modal--cart-drawer");
      _stores.quickView.show = false;
    }
  }, "handleAddToCart");
  const handleBackInStockNotification = /* @__PURE__ */ __name(async (e) => {
    var _a2;
    if ((_a2 = state == null ? void 0 : state.selected_variant) == null ? void 0 : _a2.available) return;
    e.preventDefault();
    e.stopPropagation();
    _stores.modal.setId("back_in_stock");
    _stores.backInStockNotification.product = state.product;
    _stores.backInStockNotification.selected_variant = state.selected_variant;
  }, "handleBackInStockNotification");
  const setSelectedVariant = /* @__PURE__ */ __name((id, scroll_to_variant = true) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2, _p2, _q2, _r2, _s2, _t2, _u2, _v2, _w2, _x2;
    state.selected_variant = (_a2 = state.product.variants) == null ? void 0 : _a2.find((variant) => variant.id === id);
    state.options = (_b2 = state.selected_variant) == null ? void 0 : _b2.options;
    if (state.selected_selling_plan && !((_d2 = (_c2 = state.selected_variant) == null ? void 0 : _c2.selling_plan_allocations) == null ? void 0 : _d2.some(
      (plan) => {
        var _a3, _b3;
        return ((_a3 = plan == null ? void 0 : plan.selling_plan) == null ? void 0 : _a3.id) === ((_b3 = state.selected_selling_plan) == null ? void 0 : _b3.id);
      }
    ))) {
      state.selected_selling_plan = (_h2 = (_g2 = (_f2 = (_e2 = state.selected_variant) == null ? void 0 : _e2.selling_plan_allocations) == null ? void 0 : _f2[0]) == null ? void 0 : _g2.selling_plan) != null ? _h2 : null;
    }
    if (state.product.requires_selling_plan && !state.selected_selling_plan) {
      state.selected_selling_plan = (_o2 = (_k2 = (_j2 = (_i2 = state.selected_variant) == null ? void 0 : _i2.selling_plan_allocations) == null ? void 0 : _j2[0]) == null ? void 0 : _k2.selling_plan) != null ? _o2 : (_n2 = (_m2 = (_l2 = state.product.selling_plan_groups) == null ? void 0 : _l2[0]) == null ? void 0 : _m2.selling_plans) == null ? void 0 : _n2[0];
    }
    const selected_variant_media_id = (gallerySettings == null ? void 0 : gallerySettings.filter_images) === "variant_images_by_metafield" ? (_s2 = (_r2 = (_q2 = (_p2 = state.selected_variant) == null ? void 0 : _p2.metafields) == null ? void 0 : _q2.smart) == null ? void 0 : _r2.images[0]) == null ? void 0 : _s2.id : (_u2 = (_t2 = state.selected_variant) == null ? void 0 : _t2.featured_media) == null ? void 0 : _u2.id;
    if ((gallerySettings == null ? void 0 : gallerySettings.scroll_to_selected_variant_image) && selected_variant_media_id && scroll_to_variant) {
      scrollToMediaById(selected_variant_media_id, false);
    }
    _product.lastOptions = {
      ...(_v2 = _product.lastOptions) != null ? _v2 : {},
      ...(_x2 = (_w2 = state.product.options_with_values) == null ? void 0 : _w2.reduce((acc, option, index) => {
        acc[utils.handlelize(option == null ? void 0 : option.name)] = state.options[index];
        return acc;
      }, {})) != null ? _x2 : {}
    };
  }, "setSelectedVariant");
  const setProductOption = /* @__PURE__ */ __name(({ index, value }) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2;
    const options = [...state.options];
    options[index] = value;
    setSelectedVariant(
      (_o2 = (_k2 = (_g2 = (_c2 = (_b2 = (_a2 = state.product) == null ? void 0 : _a2.variants) == null ? void 0 : _b2.find((variant) => variant.options.every((option, i) => options[i] === option))) == null ? void 0 : _c2.id) != null ? _g2 : (_f2 = (_e2 = (_d2 = state.product) == null ? void 0 : _d2.variants) == null ? void 0 : _e2.find((variant) => variant.options[index] === value)) == null ? void 0 : _f2.id) != null ? _k2 : (_j2 = (_i2 = (_h2 = state.product) == null ? void 0 : _h2.variants) == null ? void 0 : _i2.find(({ available }) => available)) == null ? void 0 : _j2.id) != null ? _o2 : (_n2 = (_m2 = (_l2 = state.product) == null ? void 0 : _l2.variants) == null ? void 0 : _m2[0]) == null ? void 0 : _n2.id
    );
  }, "setProductOption");
  const setSellingPlan = /* @__PURE__ */ __name((selling_plan_id) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2;
    state.selected_selling_plan = (_a2 = state.selling_plan_allocations.find(
      (allocation) => allocation.selling_plan.id === selling_plan_id
    )) == null ? void 0 : _a2.selling_plan;
    if (state.selected_selling_plan) {
      state.last_selected_selling_plan = state.selected_selling_plan;
    }
    const selling_plan = (_c2 = state.selected_selling_plan) != null ? _c2 : (_b2 = selling_plan_allocations == null ? void 0 : selling_plan_allocations[0]) == null ? void 0 : _b2.selling_plan;
    state.selling_plan_discount_wording = ((_e2 = (_d2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _d2[0]) == null ? void 0 : _e2.value) ? ((_g2 = (_f2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _f2[0]) == null ? void 0 : _g2.value_type) === "fixed_amount" ? `${utils.formatMoney((_i2 = (_h2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _h2[0]) == null ? void 0 : _i2.value)}` : ((_k2 = (_j2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _j2[0]) == null ? void 0 : _k2.value_type) === "percentage" ? `${(_m2 = (_l2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _l2[0]) == null ? void 0 : _m2.value}%` : "" : "";
  }, "setSellingPlan");
  const setSiblingProduct = /* @__PURE__ */ __name((handle, quickView2) => {
    var _a2, _b2, _c2;
    if (handle === state.product.handle) return;
    _product.lastOptions = {
      ...(_a2 = _product.lastOptions) != null ? _a2 : {},
      ...(_c2 = (_b2 = state.product.options_with_values) == null ? void 0 : _b2.reduce((acc, option, index) => {
        acc[utils.handlelize(option == null ? void 0 : option.name)] = state.options[index];
        return acc;
      }, {})) != null ? _c2 : {}
    };
    if (quickView2) {
      _stores.quickView.renderQuickView(handle);
      return;
    }
    barba.go(utils.getSiblingUrl(handle));
  }, "setSiblingProduct");
  const setQuantity = /* @__PURE__ */ __name((quantity) => {
    state.quantity = quantity;
  }, "setQuantity");
  const handleStickyScroll = /* @__PURE__ */ __name(() => {
  }, "handleStickyScroll");
  const scrollToMediaById = /* @__PURE__ */ __name(async (mediaId, no_variant_select = true) => {
    var _a2, _b2, _c2, _d2;
    const isHorizontal = /* @__PURE__ */ __name(() => {
      return !!(getComputedStyle(scrollContainer).overflowY === "hidden" || getComputedStyle(scrollContainer).gridAutoFlow === "column" || scrollContainer.scrollWidth > (scrollContainer == null ? void 0 : scrollContainer.clientWidth));
    }, "isHorizontal");
    const image = gallery == null ? void 0 : gallery.querySelector(`[data-media-id="${mediaId}"]`);
    if ((thumbnailSettings == null ? void 0 : thumbnailSettings.select_variant_on_click) && no_variant_select) {
      setSelectedVariant(
        ((_a2 = state.product.variants.find((v) => {
          var _a3;
          return ((_a3 = v.featured_media) == null ? void 0 : _a3.id) === mediaId;
        })) == null ? void 0 : _a2.id) || ((_b2 = state.selected_variant) == null ? void 0 : _b2.id),
        false
      );
    }
    if (!image) return;
    await utils.delay(5);
    const header = document.querySelector(".header-sections-container");
    const offsetHeight = Math.max(180, (_d2 = (_c2 = header == null ? void 0 : header.getBoundingClientRect()) == null ? void 0 : _c2.bottom) != null ? _d2 : 0);
    const imageOffset = utils.getElementPosition(image);
    if (utils.isElementScrollable(scrollContainer)) {
      let scrollSnap = false;
      if (["snap-both", "snap-x", "snap-y"].some((c) => {
        var _a3;
        return (_a3 = scrollContainer == null ? void 0 : scrollContainer.classList) == null ? void 0 : _a3.contains(c);
      })) {
        scrollContainer == null ? void 0 : scrollContainer.classList.remove("snap-both", "snap-x", "snap-y");
        scrollSnap = true;
      }
      utils.scrollToXY(200, image.offsetLeft, image.offsetTop, scrollContainer, () => {
        if (scrollSnap) {
          scrollContainer == null ? void 0 : scrollContainer.classList.add(isHorizontal() ? "snap-x" : "snap-y");
        }
        state.selected_media_id = mediaId;
      });
    } else {
      utils.scrollToXY(
        200,
        image.offsetLeft,
        imageOffset.top - offsetHeight - +getComputedStyle(gallery).paddingTop.replace("px", ""),
        window,
        () => {
          state.selected_media_id = mediaId;
        }
      );
    }
  }, "scrollToMediaById");
  const renderProductCards = /* @__PURE__ */ __name(async (element, primary_source, secondary_source, product_class, desktop_display_limit, mobile_display_limit) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2;
    const limit = Math.max(desktop_display_limit, mobile_display_limit);
    const fallback_products = utils.JSONParse(element.getAttribute("data-fallback-products"));
    const products = [];
    switch (primary_source) {
      case "complementary": {
        (_b2 = (_a2 = state.product) == null ? void 0 : _a2.complementary_products) == null ? void 0 : _b2.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "related": {
        (_d2 = (_c2 = state.product) == null ? void 0 : _c2.related_products) == null ? void 0 : _d2.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "recently_viewed": {
        const recent_products = await Promise.all(
          (_f2 = (_e2 = window == null ? void 0 : window._recent_products) != null ? _e2 : []) == null ? void 0 : _f2.map(([handle, product_id]) => _product.getHydratedProductData(handle, product_id))
        );
        recent_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "manual": {
        fallback_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
    }
    switch (secondary_source) {
      case "complementary": {
        (_h2 = (_g2 = state.product) == null ? void 0 : _g2.complementary_products) == null ? void 0 : _h2.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "related": {
        (_j2 = (_i2 = state.product) == null ? void 0 : _i2.related_products) == null ? void 0 : _j2.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "recently_viewed": {
        const recent_products = await Promise.all(
          ((_k2 = window == null ? void 0 : window._recent_products) != null ? _k2 : []).map(([handle, product_id]) => _product.getHydratedProductData(handle, product_id))
        );
        recent_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "manual": {
        break;
      }
    }
    const renderProducts = (_o2 = (_n2 = (_m2 = (_l2 = products == null ? void 0 : products.filter((prod) => prod && prod.id !== state.product.id)) == null ? void 0 : _l2.filter((a, i, arr) => arr.findIndex((b) => b.id === a.id) === i)) == null ? void 0 : _m2.filter((prod, index) => {
      var _a3, _b3;
      return prod.handle !== ((_b3 = (_a3 = element.children) == null ? void 0 : _a3[index]) == null ? void 0 : _b3.getAttribute("data-product-handle"));
    })) == null ? void 0 : _n2.slice(0, limit)) != null ? _o2 : [];
    if (!renderProducts.length) {
      return;
    }
    const nonProductElements = element.querySelectorAll(":scope > :not([data-product-handle])");
    element.innerHTML = "";
    nonProductElements.forEach((el) => {
      element.appendChild(el);
    });
    renderProducts.forEach((prod, i, arr) => {
      var _a3;
      const node = (_a3 = document.querySelector(`[data-product-card='${product_class}']`)) == null ? void 0 : _a3.cloneNode(true);
      if (node) {
        const div = document.createElement("div");
        div.setAttribute("data-product-handle", prod.handle);
        div.setAttribute(
          "class",
          `shrink-0 max-w-full w-full h-full order-[--order] ${i > desktop_display_limit ? "mobile-only" : i > mobile_display_limit ? "desktop-tablet-only" : ""}`
        );
        div.style.setProperty("--order", `${(i + 1) * 10}`);
        node.removeAttribute(`data-product-card`);
        node.setAttribute("data-product-handle", prod.handle);
        node.setAttribute("data-product-id", prod.id);
        node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
          el.remove();
        });
        div.appendChild(node);
        element.appendChild(div);
      }
    });
  }, "renderProductCards");
  const handleImageSelection = /* @__PURE__ */ __name((filter_images, items, variant) => {
    var _a2, _b2, _c2;
    switch (filter_images) {
      case "show_all_variants": {
        items == null ? void 0 : items.forEach(({ element, mediaId }) => {
          element.classList.toggle("hidden", !state.product.variants.some((v) => {
            var _a3;
            return ((_a3 = v == null ? void 0 : v.featured_media) == null ? void 0 : _a3.id) === mediaId;
          }));
        });
        return;
      }
      case "show_all": {
        items == null ? void 0 : items.forEach(({ element, mediaId }) => element.classList.remove("hidden"));
        return;
      }
      case "selected_variant": {
        items == null ? void 0 : items.forEach(({ element, mediaId }) => {
          var _a3;
          element.classList.toggle("hidden", ((_a3 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _a3.id) !== mediaId);
        });
        return;
      }
      case "variant_images_by_order": {
        let hide = true;
        items == null ? void 0 : items.forEach(({ element, mediaId }) => {
          var _a3;
          if (((_a3 = variant.featured_media) == null ? void 0 : _a3.id) === mediaId) {
            hide = false;
            element.classList.toggle("hidden", hide);
            return;
          }
          if (state.product.variants.map((v) => {
            var _a4;
            return (_a4 = v == null ? void 0 : v.featured_media) == null ? void 0 : _a4.id;
          }).includes(mediaId)) {
            hide = true;
          }
          element.classList.toggle("hidden", hide);
        });
        return;
      }
      case "variant_images_by_metafield": {
        const selected_variant_images = (_c2 = (_b2 = (_a2 = state.selected_variant) == null ? void 0 : _a2.metafields) == null ? void 0 : _b2.smart) == null ? void 0 : _c2.images;
        items == null ? void 0 : items.forEach(({ element, mediaId, metafield }, index) => {
          const order = selected_variant_images.findIndex((m) => m.id === mediaId);
          const show = selected_variant_images == null ? void 0 : selected_variant_images.some((m) => m.id === mediaId);
          element.classList.toggle("hidden", !show);
          element.style.order = order;
        });
        return;
      }
      case "variant_images_and_unassigned": {
        items == null ? void 0 : items.forEach(({ element, mediaId }) => {
          var _a3, _b3;
          const show = ((_a3 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _a3.id) === mediaId || !state.product.variants.map((v) => {
            var _a4;
            return (_a4 = v == null ? void 0 : v.featured_media) == null ? void 0 : _a4.id;
          }).includes(mediaId);
          element.classList.toggle("hidden", !show);
          element.classList.toggle("order-first", ((_b3 = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _b3.id) === mediaId);
        });
        return;
      }
      case "only_unassigned": {
        items == null ? void 0 : items.forEach(({ element, mediaId }) => {
          const show = !state.product.variants.map((v) => {
            var _a3;
            return (_a3 = v == null ? void 0 : v.featured_media) == null ? void 0 : _a3.id;
          }).includes(mediaId);
          element.classList.toggle("hidden", !show);
        });
        return;
      }
      case "first_or_selected_image": {
        items == null ? void 0 : items.forEach(({ element, mediaId }) => {
          element.classList.toggle("hidden", state.selected_media_id !== mediaId);
        });
        return;
      }
    }
  }, "handleImageSelection");
  const showMediaGallery = /* @__PURE__ */ __name((mediaId) => {
    var _a2, _b2;
    const mediaItems = (_b2 = (_a2 = mediaElements == null ? void 0 : mediaElements.filter(
      (item) => {
        var _a3, _b3, _c2;
        return (((_a3 = getComputedStyle(item.element)) == null ? void 0 : _a3.display) !== "none" || ((_c2 = getComputedStyle((_b3 = thumbnailMediaElements == null ? void 0 : thumbnailMediaElements.find((img) => img.mediaId === item.mediaId)) == null ? void 0 : _b3.element)) == null ? void 0 : _c2.display) !== "none") && item.media;
      }
    )) == null ? void 0 : _a2.filter((a, i, arr) => arr.findIndex((b) => b.mediaId === a.mediaId) === i)) == null ? void 0 : _b2.map((item) => item.media);
    const index = mediaItems.findIndex((item) => item.id === mediaId);
    _stores.mediaGallery.showGallery({
      media: mediaItems,
      index
    });
  }, "showMediaGallery");
  const truncateChildren = /* @__PURE__ */ __name((element, container, reCalculate = false) => {
    var _a2, _b2;
    const children = [...container.children];
    if (((_a2 = children.at(-2)) == null ? void 0 : _a2.offsetLeft) + ((_b2 = children.at(-2)) == null ? void 0 : _b2.clientWidth) < container.clientWidth) {
      return children.length - 1;
    }
    if (container.clientWidth === 0) {
      return container.children.length;
    }
    return children.findIndex(
      (childElement) => childElement.offsetLeft + childElement.clientWidth + element.clientWidth + +getComputedStyle(container).gap.replace("px", "") + 15 > container.clientWidth
    ) - 1;
  }, "truncateChildren");
  const hasAvailableVariant = /* @__PURE__ */ __name((index, value) => {
    var _a2, _b2;
    return (_b2 = (_a2 = state == null ? void 0 : state.product) == null ? void 0 : _a2.variants) == null ? void 0 : _b2.some((variant) => {
      switch (index) {
        case 0: {
          return variant.options[index] === value && variant.available;
        }
        case 1: {
          return variant.options[0] === (state == null ? void 0 : state.options[0]) && variant.options[index] === value && variant.available;
        }
        case 2: {
          return variant.options[0] === (state == null ? void 0 : state.options[0]) && variant.options[1] === (state == null ? void 0 : state.options[1]) && variant.options[index] === value && variant.available;
        }
      }
      return false;
    });
  }, "hasAvailableVariant");
  const getContentLabels = /* @__PURE__ */ __name((key) => {
    const labels = key.split(".").reduce((acc, selector) => {
      if (!selector || acc === void 0 || acc === null) return acc || "";
      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);
    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  }, "getContentLabels");
  const getDiscountLabel = /* @__PURE__ */ __name((type) => {
    var _a2, _b2, _c2, _d2, _e2;
    const price = (_b2 = (_a2 = state.selected_variant) == null ? void 0 : _a2.price) != null ? _b2 : 0;
    const compare_at_price = (_d2 = (_c2 = state.selected_variant) == null ? void 0 : _c2.compare_at_price) != null ? _d2 : 0;
    if (compare_at_price <= price) {
      return "";
    }
    switch (type) {
      case "sale": {
        return "On Sale";
      }
      case "percentage": {
        return `${Math.round((compare_at_price - price) * 100 / compare_at_price)}% off`;
      }
      case "value": {
        return `Save ${utils.formatMoney(
          compare_at_price - price,
          (_e2 = window == null ? void 0 : window.money_format) == null ? void 0 : _e2.replace(/\{(\s*)amount(\s*)}/gi, "{$1amount_no_decimals$2}")
        )}`;
      }
      default: {
        return "";
      }
    }
  }, "getDiscountLabel");
  const getDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicPluralizedText(content, state);
  }, "getDynamicText");
  const setDynamicPrice = /* @__PURE__ */ __name(({
    discount = state.manual_discount,
    selected_variant: selected_variant2 = state.selected_variant,
    selling_plan = state.selected_selling_plan
  }) => {
    var _a2, _b2, _c2;
    let discounted_price2 = selected_variant2 == null ? void 0 : selected_variant2.price;
    const price_adjustment2 = (_a2 = selling_plan == null ? void 0 : selling_plan.price_adjustments) == null ? void 0 : _a2[0];
    if ((price_adjustment2 == null ? void 0 : price_adjustment2.value_type) === "fixed_amount") {
      discounted_price2 = Math.max(discounted_price2 - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value)), 0);
    }
    if ((price_adjustment2 == null ? void 0 : price_adjustment2.value_type) === "percentage") {
      discounted_price2 = Math.max(discounted_price2 - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value) / 100 * discounted_price2), 0);
    }
    if (discount) {
      discounted_price2 = Math.max(discounted_price2 - Math.round(discount / 100 * discounted_price2), 0);
    }
    let upsell_price_total = 0;
    let upsell_compare_at_price_total = 0;
    let upsell_triggered_quantity_limit = 9999999;
    state.upsell_items.forEach((value) => {
      var _a3, _b3, _c3, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2;
      let upsell_d_price = (_a3 = value == null ? void 0 : value.variant) == null ? void 0 : _a3.price;
      if (state.selected_selling_plan) {
        const upsell_price_adjustment = (_f2 = (_e2 = (_d2 = (_c3 = (_b3 = value == null ? void 0 : value.variant) == null ? void 0 : _b3.selling_plan_allocations) == null ? void 0 : _c3.find(
          (plan) => plan.selling_plan.id === state.selected_selling_plan.id
        )) == null ? void 0 : _d2.selling_plan) == null ? void 0 : _e2.price_adjustments) == null ? void 0 : _f2[0];
        if ((upsell_price_adjustment == null ? void 0 : upsell_price_adjustment.value_type) === "fixed_amount") {
          upsell_d_price = Math.max(upsell_d_price - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value)), 0);
        }
        if ((upsell_price_adjustment == null ? void 0 : upsell_price_adjustment.value_type) === "percentage") {
          upsell_d_price = Math.max(upsell_d_price - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value) / 100 * discounted_price2), 0);
        }
      }
      const upsell_available_quantity = ((_g2 = value == null ? void 0 : value.variant) == null ? void 0 : _g2.inventory_management) === "shopify" && ((_h2 = value == null ? void 0 : value.variant) == null ? void 0 : _h2.inventory_policy) === "deny" ? ((_i2 = value == null ? void 0 : value.variant) == null ? void 0 : _i2.inventory_quantity) - ((_k2 = (_j2 = cart == null ? void 0 : cart.state) == null ? void 0 : _j2.items) == null ? void 0 : _k2.reduce((acc, line) => line.variant_id === selected_variant2.id ? acc + line.quantity : acc, 0)) : 999999;
      const maxMultiplier = Math.floor(upsell_available_quantity / value.quantity);
      upsell_triggered_quantity_limit = Math.min(upsell_triggered_quantity_limit, maxMultiplier);
      upsell_price_total += upsell_d_price * value.quantity;
      upsell_compare_at_price_total += Math.max((_l2 = value == null ? void 0 : value.variant) == null ? void 0 : _l2.compare_at_price, (_m2 = value == null ? void 0 : value.variant) == null ? void 0 : _m2.price) * value.quantity;
    });
    state.quantity = Math.max(1, Math.min(state.quantity, state.available_quantity, upsell_triggered_quantity_limit));
    state.quantity_limit = Math.min(state.available_quantity, upsell_triggered_quantity_limit);
    state.upsell_total = upsell_price_total * state.quantity;
    state.upsell_compare_at_total = upsell_compare_at_price_total * state.quantity;
    state.selected_price = discounted_price2;
    state.selected_compare_at_price = Math.max(selected_variant2 == null ? void 0 : selected_variant2.compare_at_price, selected_variant2 == null ? void 0 : selected_variant2.price);
    if (discount !== state.manual_discount) {
      state.manual_discount = discount;
    }
    if ((selling_plan == null ? void 0 : selling_plan.id) !== ((_b2 = state == null ? void 0 : state.selected_selling_plan) == null ? void 0 : _b2.id)) {
      setSellingPlan(selling_plan == null ? void 0 : selling_plan.id);
    }
    if ((selected_variant2 == null ? void 0 : selected_variant2.id) !== ((_c2 = state == null ? void 0 : state.selected_variant) == null ? void 0 : _c2.id)) {
      setSelectedVariant(selected_variant2 == null ? void 0 : selected_variant2.id);
    }
  }, "setDynamicPrice");
  _product.getHydratedProductData(product.handle, product.id).then((res) => {
    var _a2, _b2, _c2;
    state.product = state.product.handle === res.handle ? res : state.product;
    state.selected_variant = (_c2 = (_b2 = (_a2 = state.product) == null ? void 0 : _a2.variants) == null ? void 0 : _b2.find((variant) => {
      var _a3;
      return variant.id === ((_a3 = state.selected_variant) == null ? void 0 : _a3.id);
    })) != null ? _c2 : state.selected_variant;
  });
  handleStickyScroll();
  Alpine.effect(() => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2, _p2, _q2, _r2, _s2, _t2, _u2, _v2, _w2, _x2, _y2, _z2, _A2, _B2, _C2;
    state.isPrimary = !isProductBar && new RegExp(`^/products/${productHandle}`, "gi").test((_a2 = _stores == null ? void 0 : _stores.router) == null ? void 0 : _a2.pathname);
    if ((state == null ? void 0 : state.isPrimary) && !window.design_mode) {
      window.onpopstate = handlePopState;
      const url = new URL(window.location.href);
      const selling_plan_id = +url.searchParams.get("selling_plan") || void 0;
      const variant_id = +url.searchParams.get("variant") || void 0;
      const remove = [];
      if (!((_b2 = state.selected_variant) == null ? void 0 : _b2.id)) {
        remove.push("variant");
      }
      if (!((_c2 = state.selected_selling_plan) == null ? void 0 : _c2.id)) {
        remove.push("selling_plan");
      }
      if (((_d2 = window == null ? void 0 : window.event) == null ? void 0 : _d2.type) === "popstate") {
        return;
      }
      if (init || ((_e2 = window == null ? void 0 : window.event) == null ? void 0 : _e2.barba_redirect)) {
        if ((product == null ? void 0 : product.handle) !== ((_f2 = state == null ? void 0 : state.product) == null ? void 0 : _f2.handle)) {
          state.product = product;
          state.upsell_items = /* @__PURE__ */ new Map();
        }
        if (variant_id !== ((_g2 = state.selected_variant) == null ? void 0 : _g2.id)) {
          state.selected_variant = ((_h2 = product == null ? void 0 : product.variants) == null ? void 0 : _h2.find((v) => v.id === variant_id)) || ((_i2 = product == null ? void 0 : product.variants) == null ? void 0 : _i2.find(
            (v) => {
              var _a3;
              return v.id && ((_a3 = product.options_with_values) == null ? void 0 : _a3.every(
                (option, i) => _product.lastOptions[utils.handlelize(option == null ? void 0 : option.name)] === v.options[i]
              ));
            }
          )) || ((_j2 = product == null ? void 0 : product.variants) == null ? void 0 : _j2.find(
            (v) => {
              var _a3;
              return v.id && ((_a3 = product.options_with_values.slice(0, product.options_with_values.length - 1)) == null ? void 0 : _a3.every((option, i) => _product.lastOptions[utils.handlelize(option == null ? void 0 : option.name)] === v.options[i]));
            }
          )) || (product.options_with_values.length >= 3 ? (_k2 = product == null ? void 0 : product.variants) == null ? void 0 : _k2.find(
            (v) => {
              var _a3;
              return v.id && ((_a3 = product.options_with_values.slice(0, product.options_with_values.length - 2)) == null ? void 0 : _a3.every((option, i) => _product.lastOptions[utils.handlelize(option == null ? void 0 : option.name)] === v.options[i]));
            }
          ) : null) || ((_l2 = product == null ? void 0 : product.variants) == null ? void 0 : _l2.find(
            (v) => {
              var _a3;
              return v.id && ((_a3 = product.options_with_values) == null ? void 0 : _a3.some(
                (option, i) => _product.lastOptions[utils.handlelize(option == null ? void 0 : option.name)] === v.options[i]
              ));
            }
          )) || ((_m2 = product == null ? void 0 : product.variants) == null ? void 0 : _m2.find((v) => v.id === product.selected_or_first_available_variant_id)) || ((_n2 = product == null ? void 0 : product.variants) == null ? void 0 : _n2[0]);
          state.selected_media_id = (_p2 = (_o2 = product == null ? void 0 : product.media) == null ? void 0 : _o2[0]) == null ? void 0 : _p2.id;
          state.properties = {};
          state.selling_plan_allocations = selling_plan_allocations;
          let discounted_price2 = (_q2 = state.selected_variant) == null ? void 0 : _q2.price;
          const price_adjustment2 = (_s2 = (_r2 = state.selected_selling_plan) == null ? void 0 : _r2.price_adjustments) == null ? void 0 : _s2[0];
          if ((price_adjustment2 == null ? void 0 : price_adjustment2.value_type) === "fixed_amount") {
            discounted_price2 = Math.max(discounted_price2 - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value)), 0);
          }
          if ((price_adjustment2 == null ? void 0 : price_adjustment2.value_type) === "percentage") {
            discounted_price2 = Math.max(discounted_price2 - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value) / 100 * discounted_price2), 0);
          }
          if (state.manual_discount) {
            discounted_price2 = Math.max(discounted_price2 - Math.round(state.manual_discount / 100 * discounted_price2), 0);
          }
          let upsell_price_total = 0;
          let upsell_compare_at_price_total = 0;
          let upsell_triggered_quantity_limit = 9999999;
          state.upsell_items.forEach((value) => {
            var _a3, _b3, _c3, _d3, _e3, _f3, _g3, _h3, _i3, _j3, _k3, _l3, _m3;
            let upsell_d_price = (_a3 = value == null ? void 0 : value.variant) == null ? void 0 : _a3.price;
            if (state.selected_selling_plan) {
              const upsell_price_adjustment = (_f3 = (_e3 = (_d3 = (_c3 = (_b3 = value == null ? void 0 : value.variant) == null ? void 0 : _b3.selling_plan_allocations) == null ? void 0 : _c3.find(
                (plan) => plan.selling_plan.id === state.selected_selling_plan.id
              )) == null ? void 0 : _d3.selling_plan) == null ? void 0 : _e3.price_adjustments) == null ? void 0 : _f3[0];
              if ((upsell_price_adjustment == null ? void 0 : upsell_price_adjustment.value_type) === "fixed_amount") {
                upsell_d_price = Math.max(upsell_d_price - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value)), 0);
              }
              if ((upsell_price_adjustment == null ? void 0 : upsell_price_adjustment.value_type) === "percentage") {
                upsell_d_price = Math.max(upsell_d_price - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value) / 100 * discounted_price2), 0);
              }
            }
            const upsell_available_quantity = ((_g3 = value == null ? void 0 : value.variant) == null ? void 0 : _g3.inventory_management) === "shopify" && ((_h3 = value == null ? void 0 : value.variant) == null ? void 0 : _h3.inventory_policy) === "deny" ? ((_i3 = value == null ? void 0 : value.variant) == null ? void 0 : _i3.inventory_quantity) - ((_k3 = (_j3 = cart == null ? void 0 : cart.state) == null ? void 0 : _j3.items) == null ? void 0 : _k3.reduce(
              (acc, line) => line.variant_id === selected_variant.id ? acc + line.quantity : acc,
              0
            )) : 999999;
            const maxMultiplier = Math.floor(upsell_available_quantity / value.quantity);
            upsell_triggered_quantity_limit = Math.min(upsell_triggered_quantity_limit, maxMultiplier);
            upsell_price_total += upsell_d_price * value.quantity;
            upsell_compare_at_price_total += Math.max((_l3 = value == null ? void 0 : value.variant) == null ? void 0 : _l3.compare_at_price, (_m3 = value == null ? void 0 : value.variant) == null ? void 0 : _m3.price) * value.quantity;
          });
          state.quantity = Math.max(1, Math.min(state.quantity, state.available_quantity, upsell_triggered_quantity_limit));
          state.quantity_limit = Math.min(state.available_quantity, upsell_triggered_quantity_limit);
          state.upsell_total = upsell_price_total * state.quantity;
          state.upsell_compare_at_total = upsell_compare_at_price_total * state.quantity;
          state.selected_price = discounted_price2;
          state.selected_compare_at_price = Math.max((_t2 = state.selected_variant) == null ? void 0 : _t2.compare_at_price, (_u2 = state.selected_variant) == null ? void 0 : _u2.price);
          state.dynamic_buy_button = null;
          state.options = (_v2 = state.selected_variant) == null ? void 0 : _v2.options;
        }
        if (selling_plan_id !== ((_w2 = state.selected_selling_plan) == null ? void 0 : _w2.id)) {
          state.selected_selling_plan = (_y2 = (_x2 = state.selected_variant.selling_plan_allocations) == null ? void 0 : _x2.find(
            (plan) => plan.selling_plan_id === selling_plan_id
          )) == null ? void 0 : _y2.selling_plan;
        }
        return;
      }
      if (selling_plan_id !== ((_z2 = state.selected_selling_plan) == null ? void 0 : _z2.id) || variant_id !== ((_A2 = state.selected_variant) == null ? void 0 : _A2.id)) {
        url.searchParams.set("selling_plan", `${(_B2 = state.selected_selling_plan) == null ? void 0 : _B2.id}`);
        url.searchParams.set("variant", `${(_C2 = state.selected_variant) == null ? void 0 : _C2.id}`);
        remove.forEach((key) => {
          url.searchParams.delete(key);
        });
        barba.history.add(url.toString(), "barba", !variant_id ? "replace" : "replace");
      }
    }
  });
  Alpine.effect(() => {
    var _a2, _b2, _c2;
    if (state.dynamic_buy_button) {
      state.dynamic_buy_button.disabled = !((_a2 = state.selected_variant) == null ? void 0 : _a2.available);
      if (!((_b2 = state.dynamic_buy_button) == null ? void 0 : _b2.hasAttribute("data-no-out-of-stock"))) {
        state.dynamic_buy_button.classList.toggle("dynamic-buy-button-out-of-stock", !((_c2 = state.selected_variant) == null ? void 0 : _c2.available));
      }
    }
  });
  Alpine.effect(() => {
    var _a2;
    if (quickView) {
      (_a2 = Shopify == null ? void 0 : Shopify.PaymentButton) == null ? void 0 : _a2.init();
      handleImageSelection(gallerySettings == null ? void 0 : gallerySettings.filter_images, mediaElements, state.selected_variant);
      if (thumbnailSettings) {
        handleImageSelection(thumbnailSettings == null ? void 0 : thumbnailSettings.thumbnail_filter_images, thumbnailMediaElements, state.selected_variant);
      }
      return;
    }
    handleImageSelection(gallerySettings == null ? void 0 : gallerySettings.filter_images, mediaElements, state.selected_variant);
    if (thumbnailSettings) {
      handleImageSelection(thumbnailSettings == null ? void 0 : thumbnailSettings.thumbnail_filter_images, thumbnailMediaElements, state.selected_variant);
    }
  });
  Alpine.effect(() => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2;
    let discounted_price2 = (_a2 = state.selected_variant) == null ? void 0 : _a2.price;
    const price_adjustment2 = (_c2 = (_b2 = state.selected_selling_plan) == null ? void 0 : _b2.price_adjustments) == null ? void 0 : _c2[0];
    const product2 = state.product;
    const selected_variant2 = state.selected_variant;
    state.hasVariants = ((_d2 = product2 == null ? void 0 : product2.variants) == null ? void 0 : _d2.length) > 1 || ((_f2 = (_e2 = product2 == null ? void 0 : product2.variants) == null ? void 0 : _e2[0]) == null ? void 0 : _f2.title) !== "Default Title";
    state.hasSubscription = !!((_g2 = selected_variant2 == null ? void 0 : selected_variant2.options) == null ? void 0 : _g2.length);
    state.soldOut = (selected_variant2 == null ? void 0 : selected_variant2.inventory_management) === "shopify" && (selected_variant2 == null ? void 0 : selected_variant2.inventory_policy) === "deny" && (selected_variant2 == null ? void 0 : selected_variant2.inventory_quantity) - ((_i2 = (_h2 = cart == null ? void 0 : cart.state) == null ? void 0 : _h2.items) == null ? void 0 : _i2.reduce((acc, line) => line.variant_id === selected_variant2.id ? acc + line.quantity : acc, 0)) <= 0;
    state.available_quantity = (selected_variant2 == null ? void 0 : selected_variant2.inventory_management) === "shopify" && (selected_variant2 == null ? void 0 : selected_variant2.inventory_policy) === "deny" ? (selected_variant2 == null ? void 0 : selected_variant2.inventory_quantity) - ((_k2 = (_j2 = cart == null ? void 0 : cart.state) == null ? void 0 : _j2.items) == null ? void 0 : _k2.reduce((acc, line) => line.variant_id === selected_variant2.id ? acc + line.quantity : acc, 0)) : 999999;
    if ((price_adjustment2 == null ? void 0 : price_adjustment2.value_type) === "fixed_amount") {
      discounted_price2 = Math.max(discounted_price2 - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value)), 0);
    }
    if ((price_adjustment2 == null ? void 0 : price_adjustment2.value_type) === "percentage") {
      discounted_price2 = Math.max(discounted_price2 - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value) / 100 * discounted_price2), 0);
    }
    if (state.manual_discount) {
      discounted_price2 = Math.max(discounted_price2 - Math.round(state.manual_discount / 100 * discounted_price2), 0);
    }
    let upsell_price_total = 0;
    let upsell_compare_at_price_total = 0;
    let upsell_triggered_quantity_limit = 9999999;
    state.upsell_items.forEach((value) => {
      var _a3, _b3, _c3, _d3, _e3, _f3, _g3, _h3, _i3, _j3, _k3, _l3, _m3;
      let upsell_d_price = (_a3 = value == null ? void 0 : value.variant) == null ? void 0 : _a3.price;
      if (state.selected_selling_plan) {
        const upsell_price_adjustment = (_f3 = (_e3 = (_d3 = (_c3 = (_b3 = value == null ? void 0 : value.variant) == null ? void 0 : _b3.selling_plan_allocations) == null ? void 0 : _c3.find(
          (plan) => plan.selling_plan.id === state.selected_selling_plan.id
        )) == null ? void 0 : _d3.selling_plan) == null ? void 0 : _e3.price_adjustments) == null ? void 0 : _f3[0];
        if ((upsell_price_adjustment == null ? void 0 : upsell_price_adjustment.value_type) === "fixed_amount") {
          upsell_d_price = Math.max(upsell_d_price - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value)), 0);
        }
        if ((upsell_price_adjustment == null ? void 0 : upsell_price_adjustment.value_type) === "percentage") {
          upsell_d_price = Math.max(upsell_d_price - Math.round(+(price_adjustment2 == null ? void 0 : price_adjustment2.value) / 100 * discounted_price2), 0);
        }
      }
      const upsell_available_quantity = ((_g3 = value == null ? void 0 : value.variant) == null ? void 0 : _g3.inventory_management) === "shopify" && ((_h3 = value == null ? void 0 : value.variant) == null ? void 0 : _h3.inventory_policy) === "deny" ? ((_i3 = value == null ? void 0 : value.variant) == null ? void 0 : _i3.inventory_quantity) - ((_k3 = (_j3 = cart == null ? void 0 : cart.state) == null ? void 0 : _j3.items) == null ? void 0 : _k3.reduce((acc, line) => line.variant_id === selected_variant2.id ? acc + line.quantity : acc, 0)) : 999999;
      const maxMultiplier = Math.floor(upsell_available_quantity / value.quantity);
      upsell_triggered_quantity_limit = Math.min(upsell_triggered_quantity_limit, maxMultiplier);
      upsell_price_total += upsell_d_price * value.quantity;
      upsell_compare_at_price_total += Math.max((_l3 = value == null ? void 0 : value.variant) == null ? void 0 : _l3.compare_at_price, (_m3 = value == null ? void 0 : value.variant) == null ? void 0 : _m3.price) * value.quantity;
    });
    state.quantity = Math.max(1, Math.min(state.quantity, state.available_quantity, upsell_triggered_quantity_limit));
    state.quantity_limit = Math.min(state.available_quantity, upsell_triggered_quantity_limit);
    state.upsell_total = upsell_price_total * state.quantity;
    state.upsell_compare_at_total = upsell_compare_at_price_total * state.quantity;
    state.selected_price = discounted_price2;
    state.selected_compare_at_price = Math.max((_l2 = state.selected_variant) == null ? void 0 : _l2.compare_at_price, (_m2 = state.selected_variant) == null ? void 0 : _m2.price);
  });
  const mutationObserver = new MutationObserver((e) => {
    e == null ? void 0 : e.forEach((record) => {
      var _a2;
      const nodes = [];
      (_a2 = record == null ? void 0 : record.addedNodes) == null ? void 0 : _a2.forEach((node) => {
        if (node instanceof HTMLInputElement && (node == null ? void 0 : node.tagName) === "INPUT" && node.name === "selling_plan" && node.value) {
          setSellingPlan(+node.value);
        }
      });
    });
  });
  mutationObserver.observe($formEl, { childList: true, subtree: true });
  if (state.isPrimary) {
    Alpine.store("main_product", {
      state,
      settings,
      handleAddToCart,
      handleBackInStockNotification,
      styleDynamicBuyButton,
      setSelectedVariant,
      setProductOption,
      setSiblingProduct,
      setSellingPlan,
      setQuantity,
      handleStickyScroll,
      scrollToMediaById,
      showMediaGallery,
      truncateChildren,
      renderProductCards,
      hasAvailableVariant,
      getContentLabels,
      getDiscountLabel,
      getDynamicText
    });
    const main_product = Alpine.store("main_product");
    Alpine.magic("main_product", () => main_product);
    window._stores["main_product"] = main_product;
  }
  init = false;
  return {
    pdp: state,
    settings,
    handleAddToCart,
    handleBackInStockNotification,
    styleDynamicBuyButton,
    setSelectedVariant,
    setProductOption,
    setSiblingProduct,
    setSellingPlan,
    setQuantity,
    handleStickyScroll,
    scrollToMediaById,
    showMediaGallery,
    truncateChildren,
    renderProductCards,
    hasAvailableVariant,
    getContentLabels,
    getDiscountLabel,
    getDynamicText,
    setDynamicPrice
  };
}, "initMainProduct");
window._sections["initMainProduct"] = initMainProduct;
